import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// Phase 3 & 4----------------------------------------------------------------------------------------

// récupérer tous les visiteurs
export const getAllVisitors = async (context) => {
  const response = await axios.get(
    apiPaths.baseUrl + "/api/visitor/getAllVisitors",
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// créer un visiteur
export const createVisitor = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + "/api/visitor/create",
    payload,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// récupérer un visiteur par son id
export const getVisitorById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/visitor/getById/${id}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// modifier un visiteur par son id
export const updateVisitorById = async (id, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/visitor/update/${id}`,
    payload,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// supprimer un visiteur par son id
export const deleteVisitorById = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/visitor/delete/${id}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

//-------------------------------------------------------------- Export -------------------------------------

export const exportExcelVisitorsByAcademicYear = async (
  id_academicYear,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/exporte/visitors/${id_academicYear}`,
    {
      headers: setHeaders(context),
      responseType: "blob",
    },
  );
  return response.data;
};
